import { isEmpty } from 'lodash';
import React, { Fragment, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { LayoutBar } from '../components/Layout';
import { useRoutePermission } from '../hooks';
import { useAppSelector } from '../reducer/hooks';
import { selectProfile } from '../reducer/profileSlice';
import { ROUTE_INFOS, RouteInfo } from '../routes';

interface IProps {}

const AuthenticatedRoutes = (props: IProps) => {
  const { hasRoutePermission } = useRoutePermission();
  const navigate = useNavigate();
  const profile = useAppSelector(selectProfile);

  const withPermission = (routeInfos: RouteInfo[]) =>
    routeInfos.filter(({ key }) => hasRoutePermission(key));

  const createRoutes = (routeInfos: RouteInfo[]): React.ReactElement => {
    return (
      <>
        {routeInfos.map((routeInfo: RouteInfo) => {
          const { key, route, element, children } = routeInfo;

          if (children && children.length > 0) {
            return createRoutes(withPermission(children));
          }

          return <Route key={key} path={route} element={element} />;
        })}
      </>
    );
  };

  const authorizedRoutes = createRoutes(withPermission(ROUTE_INFOS));

  // Auto Navigate to /transactionRequest
  useEffect(() => {
    const levelPermissionFeatureList = profile.featureList.filter(
      (item) => item.substring(0, 31) === 'transaction_request/view/level_'
    );
    if (isEmpty(levelPermissionFeatureList)) {
      return navigate(`/`);
    }
    const acceptLevelListsWithPermission = levelPermissionFeatureList.map((item) =>
      item.substring(31)
    );
    navigate(`/transactionRequest?acceptLevel=${acceptLevelListsWithPermission?.at(0)}`);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LayoutBar />}>
        {authorizedRoutes}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
    </Routes>
  );
};

export default AuthenticatedRoutes;
